import styled from 'styled-components';

export const AlertsIconWrapper = styled.div`
    width: 40px;
    margin: 10px 0 0 10px;
`;
